"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.getSelectedInRect = exports.isRectSelecting = exports.get = void 0;
var distanceUtil_sidecar_1 = require("@lib/distanceUtil-sidecar");
var imports_1 = require("@lib/imports");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageUiCanvas_sidecar_1 = require("@voyage/ui/voyageUiCanvas-sidecar");
var voyagePicker_sidecar_1 = require("@voyage/ui-cursors/voyagePicker-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
function isRectSelecting() {
    var obj = get();
    return obj.isDown && obj.hasTravelledEnough;
}
exports.isRectSelecting = isRectSelecting;
function getSelectedInRect() {
    var obj = get();
    if (!isRectSelecting()) {
        return null;
    }
    var closestCrew = null;
    var closestCrewDistance = 99999;
    var mou = voyageCamera_sidecar_1.voyageCamera.getAdjustedMousePosition();
    var sxy = { x: mathUtils_sidecar_1.mathUtils.min(obj.sx, mou.x), y: mathUtils_sidecar_1.mathUtils.min(obj.sy, mou.y) };
    var exy = { x: mathUtils_sidecar_1.mathUtils.max(obj.sx, mou.x), y: mathUtils_sidecar_1.mathUtils.max(obj.sy, mou.y) };
    var cxy = { x: (sxy.x + exy.x) / 2, y: (sxy.y, exy.y) / 2 };
    imports_1.l.forEach(diveCrew_sidecar_1.diveCrew.getAll(), function (c) {
        var dist = distanceUtil_sidecar_1.distanceUtil.distanceNormalXY(cxy, c);
        if (dist < closestCrewDistance) {
            // Ensure in rect
            if (c.x < sxy.x) {
                return;
            }
            if (c.y < sxy.y) {
                return;
            }
            if (c.x > exy.x) {
                return;
            }
            if (c.y > exy.y) {
                return;
            }
            if (c.type === diveCrew_1.EVoyageCrewType.Hero && !c.isDead) {
                closestCrewDistance = dist;
                closestCrew = c;
            }
        }
    });
    return closestCrew;
}
exports.getSelectedInRect = getSelectedInRect;
var create = function () {
    var tw = 0;
    var th = 0;
    var canvas = voyageUiCanvas_sidecar_1.voyageUiCanvas.create(tw, th, voyageLayers_sidecar_1.voyageLayers.getLayers().uiGame);
    canvas.autoOffset = false;
    var obj = voyageUiCanvas_sidecar_1.voyageUiCanvas.assign(canvas, {
        sx: 0,
        sy: 0,
        isDown: false,
        hasTravelledEnough: false,
    });
    voyageUiCanvas_sidecar_1.voyageUiCanvas.setOpen(obj, true);
    return obj;
};
var render = function () {
    var obj = get();
    var g = obj.graphics;
    voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    if (!obj.isDown) {
        return;
    }
    var color = voyageColors_sidecar_1.voyageColors.yellow;
    var uisxy = voyageCamera_sidecar_1.voyageCamera.getGamePositionToUiPosition(obj.sx, obj.sy);
    var mou = voyageCamera_sidecar_1.voyageCamera.getUiMousePosition();
    var rw = mou.mx - uisxy.x;
    var rh = mou.my - uisxy.y;
    if (Math.abs(rw) + Math.abs(rh) > 20) {
        obj.hasTravelledEnough = true;
    }
    if (obj.hasTravelledEnough) {
        g.lineStyle(2, color, 1);
        g.strokeRect(uisxy.x, uisxy.y, rw, rh);
        voyageUiCanvas_sidecar_1.voyageUiCanvas.render(obj);
    }
};
var update = function () {
    var obj = get();
    voyageUiCanvas_sidecar_1.voyageUiCanvas.update(obj);
    var mou = voyageCamera_sidecar_1.voyageCamera.getAdjustedMousePosition();
    if (clickEater_sidecar_1.clickEater.isLeftFirstDownAndUneaten()) {
        obj.hasTravelledEnough = false;
        obj.sx = mou.x;
        obj.sy = mou.y;
        obj.isDown = true;
    }
    if (clickEater_sidecar_1.clickEater.isLeftUpRegardless()) {
        if (isRectSelecting()) {
            // TODO: fix rect selecting
            voyagePicker_sidecar_1.voyagePicker.nr_setSelection(getSelectedInRect());
            clickEater_sidecar_1.clickEater.tempEat();
        }
        obj.isDown = false;
    }
    // if (clickEater.isLeftFirstUpAndUneaten()) {
    // }
    render();
};
exports.update = update;
